export function formatViews(n: number): string {
  if (n >= 100000000) {
    const v = n / 100000000;
    return `${v.toFixed(1).replace(/\.0$/, '')}亿`;
  }
  if (n >= 10000) {
    const v = n / 10000;
    return `${v.toFixed(1).replace(/\.0$/, '')}万`;
  }
  return String(n);
}

export function formatCount(n: number): string {
  if (n >= 10000) {
    const v = n / 10000;
    return `${v.toFixed(1).replace(/\.0$/, '')}万`;
  }
  return String(n);
}